module.exports = __webpack_public_path__ + "src/img/tip.70965bea.svg";